import { useState, useEffect, useContext } from "react";
import { store } from "../store.js";
import axios from "axios";

function useVehiclesList() {
    const { dispatch, state } = useContext(store);
    const [isLoading, setIsLoading] = useState(false);
    const [isError, setIsError] = useState(false);

    useEffect(() => {
        const fetchData = async () => {
            setIsError(false);
            setIsLoading(true);

            try {
                const result = await axios("/api/vehicles");
                dispatch({
                    type: "UPDATE_VEHICLES_LIST",
                    data: result.data
                });
            } catch (error) {
                setIsError(true);
            }

            setIsLoading(false);
        };
        fetchData();
    }, []);

    return [state.listVehicles, isLoading, isError];
}

export default useVehiclesList;
